import PropTypes from 'prop-types';
import React, { Component } from 'react';import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import classnames from 'classnames';
import Lib from '../../commons/lib';
import VasarloiKartyaContent from './VasarloiKartya/VasarloiKartyaContent';
import FunkcioKedvezmenyContent from './FunkcioKedvezmeny/FunkcioKedvezmenyContent';
import KedvezmenyContent from './Kedvezmeny/KedvezmenyContent';
import KartyaTipusContent from './KartyaTipus/KartyaTipusContent';
import KartyaGeneralasContent from './KartyaGeneralas/KartyaGeneralasContent';
import ListaContent from './Listak/ListaContent';
import CustomTooltip from '../../components/Tooltip/CustomTooltip';
import getTooltip from './KedvezmenyTooltips';

class KedvezmenyBase extends Component {
  constructor (props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '0',
      show: false
    };
  }
 
  componentDidMount() {
    if (this.props.globals.hasRole(['KEDVEZMENY_KEDVEZMENY'])) {
      this.toggle('1');
    } else if (this.props.globals.hasRole(['KEDVEZMENY_VKTIPUS'])) {
      this.toggle('2');
    } else if (this.props.globals.hasRole(['KEDVEZMENY_VK'])) {
      this.toggle('3');
    } else if (this.props.globals.hasRole(['KEDVEZMENY_VKGEN'])) {
      this.toggle('4');
    } else if (this.props.globals.hasRole(['KEDVEZMENY_FUNKKEDV'])) {
      this.toggle('5');
    } else if (this.props.globals.hasRoleSpec(['KEDVEZMENY_LISTA_FORGALOM']) || this.props.globals.hasRoleSpec(['KEDVEZMENY_LISTA_FELHASZNALAS'])) {
      this.toggle('6');
    }
  }

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  render() {
    let cardStyle = {
      padding: 10
    };

    const {
      activeTab
    } = this.state;

    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              Kedvezmény
              {/* <YouTube data={videoData} /> */}
            </div>
            <div style={cardStyle}>
              <div className="col-md-12">
                <Nav tabs>
                  {
                    this.props.globals.hasRole(['KEDVEZMENY_KEDVEZMENY']) &&
                    <NavItem>
                      <NavLink href="#" className={classnames({ active: activeTab === '1' })} onClick={() => { this.toggle('1'); }}>
                        Kedvezmény
                        <CustomTooltip text={getTooltip('kedvezmeny')} id="kedvezmenyTT" />
                      </NavLink>
                    </NavItem>
                  }
                  {
                    this.props.globals.hasRole(['KEDVEZMENY_VKTIPUS']) &&
                    <NavItem>
                      <NavLink href="#" className={classnames({ active: activeTab === '2' })} onClick={() => { this.toggle('2'); }}>
                        Vásárlói kártyatípus
                        <CustomTooltip text={getTooltip('vasarloikartyatipus')} id="vasarloikartyatipusTT" />
                      </NavLink>
                    </NavItem>
                  }
                  {
                    this.props.globals.hasRole(['KEDVEZMENY_VK']) &&
                    <NavItem>
                      <NavLink href="#" className={classnames({ active: activeTab === '3' })} onClick={() => { this.toggle('3'); }}>
                        Vásárlói kártya
                        <CustomTooltip text={getTooltip('vasarloikartya')} id="vasarloikartyaTT" />
                      </NavLink>
                    </NavItem>
                  }
                  {
                    this.props.globals.hasRole(['KEDVEZMENY_VKGEN']) &&
                    <NavItem>
                      <NavLink href="#" className={classnames({ active: activeTab === '4' })} onClick={() => { this.toggle('4'); }}>
                        Kártya generálás
                        <CustomTooltip text={getTooltip('kartyageneralas')} id="kartyageneralasTT" />
                      </NavLink>
                    </NavItem>
                  }
                  {
                    this.props.globals.hasRole(['KEDVEZMENY_FUNKKEDV']) &&
                    <NavItem>
                      <NavLink href="#" className={classnames({ active: activeTab === '5' })} onClick={() => { this.toggle('5'); }}>
                        Funkció-kedvezmény összerendelés
                        <CustomTooltip text={getTooltip('funkiokedvezmeny')} id="funkiokedvezmenyTT" />
                      </NavLink>
                    </NavItem>
                  }
                  {(this.props.globals.hasRoleSpec(['KEDVEZMENY_LISTA_FORGALOM']) || this.props.globals.hasRoleSpec(['KEDVEZMENY_LISTA_FELHASZNALAS']))  &&
                    <NavItem>
                      <NavLink href="#" className={classnames({ active: activeTab === '6' })} onClick={() => { this.toggle('6'); }}>
                        Listák
                        <CustomTooltip text={getTooltip('listak')} id="listakTT" />
                      </NavLink>
                    </NavItem>
                  }
                </Nav>
                <TabContent activeTab={activeTab}>
                  {this.props.globals.hasRole(['KEDVEZMENY_KEDVEZMENY']) &&
                    <TabPane tabId="1">
                      <KedvezmenyContent {...this.props} globals={this.props.globals} active={activeTab === '1'}/>
                    </TabPane>
                  }
                  {this.props.globals.hasRole(['KEDVEZMENY_VKTIPUS']) &&
                    <TabPane tabId="2">
                      <KartyaTipusContent {...this.props} globals={this.props.globals} active={activeTab === '2'}/>
                    </TabPane>
                  }
                  { this.props.globals.hasRole(['KEDVEZMENY_VK']) &&
                    <TabPane tabId="3">
                      <VasarloiKartyaContent {...this.props} globals={this.props.globals} active={activeTab === '3'}/>
                    </TabPane>
                  }
                  {this.props.globals.hasRole(['KEDVEZMENY_VKGEN']) &&
                    <TabPane tabId="4">
                      <KartyaGeneralasContent {...this.props} globals={this.props.globals} active={activeTab === '4'}/>
                    </TabPane>
                  }
                  {this.props.globals.hasRole(['KEDVEZMENY_FUNKKEDV']) &&
                    <TabPane tabId="5">
                      <FunkcioKedvezmenyContent {...this.props} globals={this.props.globals} active={activeTab === '5' } />
                    </TabPane>
                  }
                  {(this.props.globals.hasRoleSpec(['KEDVEZMENY_LISTA_FORGALOM']) || this.props.globals.hasRoleSpec(['KEDVEZMENY_LISTA_FELHASZNALAS'])) &&
                    <TabPane tabId="6">
                      <ListaContent {...this.props} globals={this.props.globals} active={activeTab === '6' } />
                    </TabPane>
                  }
                </TabContent>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

KedvezmenyBase.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};

export default KedvezmenyBase;
